// extracted by mini-css-extract-plugin
export var animationContainer = "_i6-0";
export var asteriskIcon = "_i6-8";
export var conversationLeftSection = "_i6-4";
export var conversationListItem = "_i6-3";
export var conversationMiddleSection = "_i6-5";
export var conversationRightSection = "_i6-6";
export var detailsContent = "_i6-1";
export var listContainer = "_i6-7";
export var modalContent = "_i6-2";